var React = require('react');

function SvgCloseInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#323023","d":"M1.774 11.265L.612 10.102l9.499-9.5 1.162 1.163z","key":0}),React.createElement("path",{"fill":"#323023","d":"M.61 1.765L1.771.603l9.5 9.499-1.163 1.162z","key":1})]);
}

SvgCloseInline.defaultProps = {"width":"12","height":"12","fill":"none"};

module.exports = SvgCloseInline;

SvgCloseInline.default = SvgCloseInline;
